module.exports = __webpack_public_path__ + "images/reality-star-34d4febfe43c25c9aaecb0cc88eeb6ba.png";